import HueRed from '@assets/hue_red.svg';
import HueYellow from '@assets/hue_yellow.svg';
import Image from '@atoms/Image/Image';
import { IImage } from '@models/IImage';
import GlowColourEnum from '@models/enums/GlowColourEnum';
import SoftLoadWrapper from '@molecules/SoftLoadWrapper/SoftLoadWrapper';
import useMediaQuery from '@utils/hooks/useMediaQuery';
import classNames from 'classnames';

interface Props {
  readonly backgroundGlow?: GlowColourEnum;
  readonly desktopImage?: IImage;
  readonly featureText: string;
  readonly leftAlignment?: boolean;
  readonly mobileImage?: IImage;
  readonly reducedPadding: boolean;
  readonly subText: string;
  readonly isHero?: boolean;
}

const SectionHeader = ({
  backgroundGlow,
  desktopImage,
  featureText,
  leftAlignment,
  mobileImage,
  reducedPadding,
  subText,
  isHero,
}: Props) => {
  const isMobile = useMediaQuery(1024);
  const imageToDisplay = isMobile ? mobileImage || desktopImage : desktopImage;
  const TitleTag = isHero ? 'h1' : 'p';

  return (
    <section
      className={classNames(
        'bg-white dark:bg-black-100',
        reducedPadding ? 'pb-10 lg:pb-20' : 'pb-13 lg:pb-[150px]'
      )}
      data-testid="CT-156-Section-Header"
    >
      <SoftLoadWrapper>
        <div className="container flex flex-col items-center justify-center gap-10 overflow-hidden">
          <div className="z-10 flex flex-col gap-7.5 xl:grid xl:grid-cols-12">
            <TitleTag
              className={classNames(
                'text-black-100 xl:col-span-6 xl:col-start-4 dark:text-white',
                leftAlignment ? 'text-left' : 'text-center',
                {
                  h2: !isHero,
                }
              )}
              data-testid="CT-156-Section-Header-Feature-Text"
            >
              {featureText}
            </TitleTag>

            <p
              className={classNames(
                'body-two xl:col-span-6 xl:col-start-4',
                leftAlignment ? 'text-left' : 'text-center',
                isHero ? 'text-white' : 'text-grey-500'
              )}
              data-testid="CT-156-Section-Header-Subtext"
            >
              {subText}
            </p>
          </div>

          {imageToDisplay && (
            <div className="relative flex h-full w-full flex-col items-center justify-center">
              {backgroundGlow !== GlowColourEnum.None && (
                <img
                  src={`${backgroundGlow === GlowColourEnum.Yellow ? HueYellow : HueRed}`}
                  alt="hue"
                  className={classNames(
                    'lg:-top-[25rem] md:-top-72 -top-[9.5rem] absolute scale-y-[0.3] opacity-40 lg:scale-x-[1.5]'
                  )}
                />
              )}

              <Image
                image={imageToDisplay}
                imageClasses="w-full h-auto"
                classes="z-10 w-full"
              />
            </div>
          )}
        </div>
      </SoftLoadWrapper>
    </section>
  );
};

export default SectionHeader;
